import { render, staticRenderFns } from "./CompareRecursive.vue?vue&type=template&id=22d8e50c&scoped=true&"
import script from "./CompareRecursive.vue?vue&type=script&lang=ts&"
export * from "./CompareRecursive.vue?vue&type=script&lang=ts&"
import style0 from "./CompareRecursive.vue?vue&type=style&index=0&id=22d8e50c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d8e50c",
  null
  
)

export default component.exports